<div class="bread-bin">
    <span class="breadcrumbs-line">
  <span class="home">
    Home: 
  </span>
    <span class="category" *ngIf="!categories"><a   [routerLink]="['category']">View Categories</a></span>
    <span class="category" *ngIf="categories">in 
      <span *ngFor="let category of categories"  ><a  [routerLink]="['category', category.id ]"> {{category.title}}</a> :</span>
    </span>
    </span>
</div>


// WEBPACK FOOTER //
// ./src/app/home-page/breadcrumbs/breadcrumbs.component.html